import { Button, Modal } from "@shopify/polaris"
import React, { useContext, useState } from "react"
import { GlobalStateContext } from "../providers/GlobalStateProvider.jsx"
import {
	AddToCartButton,
	KopyBasicItem,
	KopyPlusItem,
	KopyProtectItem,
} from "../subscription/BillingItems.jsx"
import { useUpdateSubscription } from "../../hooks/usePaddleHooks.js"
import { useTranslation } from "react-i18next"

export const SubscriptionItemSuggestions = () => {
	const { t } = useTranslation()
	const { state } = useContext(GlobalStateContext)
	const updateSubscription = useUpdateSubscription()
	const [modalIsOpen, setModalIsOpen] = useState(false)
	const [cart, setCart] = useState([])
	const [updatingSubscription, setUpdatingSubscription] = useState(false)

	const missingKopyProtect = !state.hasValidKopyProtectSubscription
	const missingKopyPlus = !state.hasValidKopyPlusSubscription
	const missingKopyBasic = !state.hasValidKopyBasicSubscription

	const toggleFromCart = (item) => {
		const isInCartAlready = cart.includes(item)

		if (isInCartAlready) {
			setCart(cart.filter((i) => i !== item))
		} else {
			setCart([...cart, item])
		}
	}

	const updateSub = async () => {
		const currentSubscription =
			state.kopyBasicSubscription || state.kopyProtectSubscription || null

		const currentSubscriptionStatus = currentSubscription?.status || null
		const currentSubscriptionBillingInterval =
			currentSubscription?.billingInterval || null
		const activeSubscriptionId = currentSubscription?.subscriptionId || null

		if (
			!activeSubscriptionId ||
			!currentSubscriptionStatus ||
			!currentSubscriptionBillingInterval
		) {
			return
		}

		const kopyBasicPriceId =
			state.pricing?.["kopy_basic"]?.[
				currentSubscriptionBillingInterval
			]?.["base"]?.[
				currentSubscriptionStatus === "active"
					? "no_trial"
					: "with_trial"
			]?.priceId || null
		const kopyProtectPriceId =
			state.pricing?.["kopy_protect"]?.[
				currentSubscriptionBillingInterval
			]?.[
				currentSubscriptionStatus === "active"
					? "no_trial"
					: "with_trial"
			]?.priceId || null
		const kopyPlusPriceId =
			state.pricing?.["kopy_plus"]?.[
				currentSubscriptionBillingInterval
			]?.[
				currentSubscriptionStatus === "active"
					? "no_trial"
					: "with_trial"
			]?.priceId || null

		if (!kopyBasicPriceId && !kopyProtectPriceId && !kopyPlusPriceId) {
			return
		}

		setUpdatingSubscription(true)
		const { success } = await updateSubscription({
			items: [
				...(kopyBasicPriceId
					? [{ price_id: kopyBasicPriceId, quantity: 1 }]
					: []),
				...(kopyProtectPriceId
					? [{ price_id: kopyProtectPriceId, quantity: 1 }]
					: []),
				...(kopyPlusPriceId
					? [{ price_id: kopyPlusPriceId, quantity: 1 }]
					: []),
			],
			prorationBillingMode: "prorated_immediately",
			subscriptionId: activeSubscriptionId,
		})

		if (success) {
			// Paddle takes a while to update the subscription sometimes
			setTimeout(() => {
				window.location.reload()
			}, 1000 * 5)
		} else {
			setUpdatingSubscription(false)
		}
	}

	if (!missingKopyBasic && !missingKopyPlus && !missingKopyProtect) {
		return null
	}

	return (
		<div>
			<Button fullWidth onClick={() => setModalIsOpen(true)}>
				{t("account.add_benefits_to_my_plan")}
			</Button>

			<Modal
				title={t("account.add_benefits_to_my_plan")}
				open={modalIsOpen}
				primaryAction={{
					content: t("common.confirm"),
					disabled: cart.length === 0,
					onAction: updateSub,
					loading: updatingSubscription,
				}}
				onClose={() => setModalIsOpen(false)}
			>
				<div
					style={{
						padding: "1rem",
						display: "flex",
						flexDirection: "column",
						gap: "0.5rem",
					}}
				>
					{missingKopyProtect && (
						<div
							style={{
								display: "flex",
								gap: "0.5rem",
								alignItems: "center",
								justifyContent: "space-between",
							}}
						>
							<KopyProtectItem displayPrice={true} />
							<AddToCartButton
								onClick={() => toggleFromCart("protect")}
								inCart={cart.includes("protect")}
							/>
						</div>
					)}
					{missingKopyPlus && (
						<div
							style={{
								display: "flex",
								gap: "0.5rem",
								alignItems: "center",
								justifyContent: "space-between",
							}}
						>
							<KopyPlusItem displayPrice={true} />
							<AddToCartButton
								onClick={() => toggleFromCart("plus")}
								inCart={cart.includes("plus")}
							/>
						</div>
					)}
					{missingKopyBasic && (
						<div
							style={{
								display: "flex",
								gap: "0.5rem",
								alignItems: "center",
								justifyContent: "space-between",
							}}
						>
							<KopyBasicItem displayPrice={true} />
							<AddToCartButton
								onClick={() => toggleFromCart("basic")}
								inCart={cart.includes("basic")}
							/>
						</div>
					)}
				</div>
			</Modal>
		</div>
	)
}
